import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { ActivatedRoute, Router } from '@angular/router'
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { UserService } from '../../../../api/services/user.service'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { LazyLoadEvent, MessageService } from 'primeng/api'
import { User } from '../../../../api/models/user'
import { DataPageOfEhrUsers } from '../../../../api/models/data-page-of-ehr-users'
import { validateAllFormFields } from '../../../../formUtils'
import { EhrUsers } from '../../../../api/models/ehr-users'
import { ManageRoles } from '../../../../api/models'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  templateUrl: './create-user.component.html',
})
export class CreateUserComponent implements OnInit, AfterViewInit {
  ehrusers: DataPageOfEhrUsers
  rows: number
  selectedEhrUsername: EhrUsers
  roles: Array<ManageRoles>
  userForm: UntypedFormGroup
  noEHRUser: UntypedFormControl
  resetPwd: UntypedFormControl
  practiceId: string
  EhrlastName: string
  EhrfirstName: string
  user: User
  userId: number
  displayEhrUsernameDialog = false
  isnoehruser: boolean = false
  edited: boolean = false
  showreset: boolean = false
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  cols: { field: string; header: string; hidden: boolean }[]
  Showrecords: boolean
  currentPage: number = 1
  first: number = 0 // Variable to track the first record
    isEmailRequird: boolean = false
    isCellRequird: boolean = false
  constructor(
    private router: Router,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {
    this.breadcrumbService.setItems([{ label: '' }])
  }

  ngOnInit() {
    debugger
    this.userForm = new UntypedFormGroup({
      userPassword: new UntypedFormControl(null, [Validators.required]),
      confirmUserPassword: new UntypedFormControl(null, [Validators.required]),
      loginId: new UntypedFormControl(null, [Validators.required]),
      lname: new UntypedFormControl(null, [Validators.required]),
        fname: new UntypedFormControl(null, [Validators.required]),
        mi: new UntypedFormControl(null, [Validators.maxLength(1)]),
      active: new UntypedFormControl(true, []),
      userType: new UntypedFormControl(null, []),
      //showSensitiveData: new FormControl(false, []),
      //showClinicalData: new FormControl(false, []),
      //showFinancialData: new FormControl(false, []),
      forcePswdChg: new UntypedFormControl(null, []),
      allowPswdChg: new UntypedFormControl(null, []),
      emailAddress: new UntypedFormControl(null, []),
      cellNo: new UntypedFormControl(null, []),
      ehrUserName: new UntypedFormControl(null, []),
      ehrUserId: new UntypedFormControl(null, [Validators.required]),
      userName: new UntypedFormControl(null, []),
      roles: new UntypedFormControl(null, [Validators.required]),
    })
    this.userForm.setValidators(
      CareFinityValidators.Match('userPassword', 'confirmUserPassword'),
    )

      if (CareFinitySession.applicationSettings.isEmailMandatory)
      {
      this.isEmailRequird = true
      this.userForm.get('emailAddress').setValidators(Validators.required)
      }

      if (CareFinitySession.applicationSettings.isCellMandatory) {
          this.isCellRequird = true
          this.userForm.get('cellNo').setValidators(Validators.required)
      }
     
    this.noEHRUser = new UntypedFormControl()
    this.noEHRUser.valueChanges.subscribe((val: boolean) => {
      console.log('Value ', val);
        if (val) {
            this.userForm.get('ehrUserId').setValue(null)
            this.userForm.get('ehrUserName').setValue(null)
            this.userForm.get('ehrUserId').clearValidators()
        
        this.userForm.updateValueAndValidity()
        this.isnoehruser = val
      } else {
        this.userForm.get('ehrUserId').setValidators(Validators.required)
        this.userForm.updateValueAndValidity()
        this.isnoehruser = val
      }
    })
    this.resetPwd = new UntypedFormControl(null, [])
    this.resetPwd.valueChanges.subscribe((val: boolean) => {
      if (val) {
        this.userForm.get('userPassword').setValidators(Validators.required)
        this.userForm
          .get('confirmUserPassword')
          .setValidators(Validators.required)
        this.edited = false
        this.userForm.updateValueAndValidity()
      } else {
        this.userForm.get('userPassword').clearValidators()
        this.userForm.get('confirmUserPassword').clearValidators()
        this.edited = true
        this.userForm.updateValueAndValidity()
      }
    })
    this.practiceId = localStorage.getItem('PracticeId') // this.route.snapshot.paramMap.get("practice_id")
    this.route.data.subscribe((data) => {
      debugger
      if (data.groups) {
        this.roles = data.groups
      }
      if (data.user) {
        debugger
        this.userId = +this.route.snapshot.paramMap.get('userid')
        this.user = data.user
        this.userForm.get('userPassword').clearValidators()
        this.userForm.get('confirmUserPassword').clearValidators()
        this.edited = true
        this.showreset = true
        this.userForm.updateValueAndValidity()
        this.userForm.patchValue(this.user)
        this.userForm.controls.roles.setValue({
          roleId: data.user.roles.roleId,
        })
        if (!this.userForm.get('ehrUserName').value) {
          this.noEHRUser.setValue(true)
        }
      }
    })

    this.cols = [
      { field: 'lastName', header: 'Last Name', hidden: false },
      { field: 'firstName', header: 'First Name', hidden: false },
      { field: 'loginID', header: 'Login Name', hidden: false },
      { field: 'isActive', header: 'Is Active', hidden: false },
      { field: 'userId', header: 'EHRUserID', hidden: true },
    ]
  }

  onRowSelect(event): void {
    console.log('selected user is ', event)
    this.displayEhrUsernameDialog = false
    this.userForm.get('ehrUserName').setValue(event.data.userName)
    this.userForm.get('ehrUserId').setValue(event.data.userId)
    this.userForm.get('loginId').setValue(event.data.loginID)
    this.userForm.get('fname').setValue(event.data.firstName)
    this.userForm.get('lname').setValue(event.data.lastName)

    this.userForm.markAsDirty()
  }

  ngAfterViewInit() {}

  save() {
    validateAllFormFields(this.userForm)
    // console.log('user Form', this.userForm);
    if (this.userForm.invalid) {
      return
      }

     // console.log(this.userForm.value);   

      const frmValues = this.userForm.value;
      const BodyDto = { ...this.userForm.value, mi: frmValues.mi == "" ? null : frmValues.mi }

      //console.log("hhhh");

      //console.log(BodyDto);
    debugger
    if (this.user == null) {
      this.userService
        .userPost({
          practiceId: this.practiceId,
          isnoehruser: this.isnoehruser,
            body: BodyDto,
        })
        .subscribe((result) => {
          if (result.status.toLowerCase().indexOf('error') > -1) {
            this.ShowErrorSummary = true
            this.errorValidationSummary = result.message

            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              detail: result.message,
              summary: 'ERROR',
              life: 7000,
            })
          } else if (result.status.toLowerCase().indexOf('ok') > -1) {
            this.ShowErrorSummary = false
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: result.message,
              summary: 'Confirmation',
              life: 7000,
            })
            this.userForm.reset()
            this.router.navigate(['administration', 'user-list'])
          }
        })
    } else {
      this.userService
        .userPut({
          userId: this.userId,
          practiceId: this.practiceId,
          isnoehruser: this.isnoehruser,
          resetPwd: this.resetPwd.value,
            body: BodyDto,
        })
        .subscribe(
          (result) => {
            console.log(result)

            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: 'User Edited Successfully',
              summary: 'Confirmation',
              life: 5000,
            })
            this.userForm.reset()
            this.router.navigate(['administration', 'user-list'])
          },
          (err) => {
            this.ShowErrorSummary = false
            this.messageService.add({
              key: 'alertToast',
                severity: 'error',
              detail: err.error,
              summary: 'ERROR',
              life: 7000,
            })
          },
        )
    }
  }

  loadEhrUsernameList(
    pageNumber: number,
    sortcolumn: string,
    sortorder: string,
  ): void {
    this.userService
      .userGetEhrUserSearch({
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        lastName: this.EhrlastName,
        firstName: this.EhrfirstName,
      })
      .subscribe((X) => {
        this.ehrusers = X
        if (this.ehrusers.totalRecords == 0) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'info',
            detail: 'No Records Found!',
            summary: 'Confirmation',
            life: 5000,
          })
        }

        this.rows = this.ehrusers.pageSize
        if (this.ehrusers.totalRecords > 0) {
          this.Showrecords = true
        } else {
          this.Showrecords = false
        }
      })
  }

  nextPage($event: LazyLoadEvent) {
    debugger
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
      this.loadEhrUsernameList(1, $event.sortField, order)
      //this.currentPage = 1;
    } else {
      this.loadEhrUsernameList(nextPage, $event.sortField, order)
      //this.currentPage = nextPage;
    }

    this.currentPage = Math.floor($event.first / $event.rows) + 1
  }

  ClearEhrList(): void {
    this.EhrlastName = ''
    this.EhrfirstName = ''
    this.loadEhrUsernameList(1, '', '')
  }
}
